import {
	SHOW_TOAST,
	HIDE_TOAST,
} from '../types';
import { i18n } from '../../i18n';
import { getErrorToastContent } from '../../assets/js/errorMessage';

let toastId = 0;

/**
 * เช็คว่า response interceptor แสดง toast ให้ error ก้อนนี้ไปแล้วหรือยัง
 *
 * interceptor (services/api/interceptors/response.js) จะ mark `_toastShown = true`
 * ทุกครั้งที่มันขึ้น toast เอง store action ที่ catch error เดิมต่อจึงต้องเช็ค flag นี้
 * ก่อนขึ้น toast ซ้ำ ไม่งั้นผู้ใช้จะเห็น error เดียวกันสองอันซ้อนกัน
 *
 * @param {*} error - axios error object ที่ store action catch มา (อาจเป็น null)
 * @returns {boolean}
 */
const isAlreadyToasted = (error) => error?._toastShown === true;

export default {
	namespaced: true,
	state: {
		list: [],
		config: {
			position: 'top-right',
		},
	},
	mutations: {
		[SHOW_TOAST](state, toast, config) {
			state.config = {
				...state.config,
				...config,
			};

			state.list = [
				...state.list,
				{
					id: toast.id,
					title: toast.title,
					content: toast.content,
					header: toast.header,
					type: toast.type,
					timeout: toast.timeout || 3000,
					isShow: true,
				},
			];
		},

		[HIDE_TOAST](state, id) {
			state.list = state.list.map((toast) => {
				return toast.id === id
					? { ...toast, isShow: false }
					: toast;
			});
		},
	},
	actions: {
		showToast({ commit }, data, config) {
			const toast = {
				id: toastId++,
				...data,
			};
			commit(SHOW_TOAST, toast, config);
		},

		hideToast({ commit }, id) {
			commit(HIDE_TOAST, id);
		},
		showCreateSuccessToast({ dispatch }, type = null) {
			dispatch(
				'showToast',
				{
					content: i18n.t('global.successMessageCreate', { type }),
					header: i18n.t('global.successMessageTitle'),
					type: 'success',
				},
			);
		},
		showCreateErrorToast({ dispatch }, error = null) {
			if (isAlreadyToasted(error)) {
				return;
			}

			dispatch(
				'showToast',
				{
					content: i18n.t('global.errorMessage'),
					header: i18n.t('global.errorMessageTitleCreate'),
					type: 'danger',
				},
			);
		},
		showUpdateSuccessToast({ dispatch }) {
			dispatch(
				'showToast',
				{
					content: i18n.t('global.successMessage'),
					header: i18n.t('global.successMessageTitle'),
					type: 'success',
				},
			);
		},
		showUpdateErrorToast({ dispatch }, error = null) {
			if (isAlreadyToasted(error)) {
				return;
			}

			dispatch(
				'showToast',
				{
					content: i18n.t('global.errorMessage'),
					header: i18n.t('global.errorMessageTitleEdit'),
					type: 'danger',
				},
			);
		},
		showDeleteSuccessToast({ dispatch }, type = null) {
			dispatch(
				'showToast',
				{
					content: i18n.t('global.successMessageDelete', { type }),
					header: i18n.t('global.successMessageTitleDelete'),
				},
			);
		},
		showDeleteErrorToast({ dispatch }, error = null) {
			if (isAlreadyToasted(error)) {
				return;
			}

			dispatch(
				'showToast',
				{
					content: i18n.t('global.errorMessage'),
					header: i18n.t('global.errorMessageTitleDelete'),
					type: 'danger',
				},
			);
		},
		showMultipleErrorsToast({ dispatch }, error = null) {
			if (isAlreadyToasted(error)) {
				return;
			}

			const errorMessage = getErrorToastContent(
				error?.response?.data,
				i18n.t('global.errorMessage'),
			);

			dispatch('showToast', {
				header: i18n.t('global.errorMessageTitleEdit'),
				content: errorMessage,
				type: 'danger',
			});
		},
		showAddUserSuccessToast({ dispatch }) {
			dispatch('toast/showToast', {
				content: 'New user has been added',
				header: i18n.t('global.successMessageTitle'),
				type: 'success',
			}, { root: true });
		},
		showAddUserErrorToast() {

			/**
			 * Show error toast when api return 404 or 422
			 */
		},
	},
};
